<template>
  <v-stepper-header
    class="elevation-0 px-5"
    style="height: 40px !important; width: 800px">
    <v-stepper-step
      class="py-2 body-2"
      :complete="stepper > 1"
      editable
      step="1">
      Tipo
    </v-stepper-step>

    <v-divider></v-divider>

    <v-stepper-step
      class="py-2 body-2"
      :complete="stepper > 2"
      editable
      step="2">
      Plan
    </v-stepper-step>

    <v-divider></v-divider>

    <v-stepper-step
      editable
      :complete="stepper > 3"
      class="py-2 body-2"
      step="3">
      Impuestos
    </v-stepper-step>

    <v-divider></v-divider>

    <v-stepper-step
      editable
      :complete="stepper > 3"
      class="py-2 body-2"
      step="4">
      Documentación
    </v-stepper-step>

    <v-divider></v-divider>

    <v-stepper-step
      editable
      class="py-2 body-2"
      step="5">
      Confirmación
    </v-stepper-step>
  </v-stepper-header>
</template>

<script>
export default {
  props: {
    stepper: {
      required: true
    }
  }
}
</script>
